import { get } from "../../service/api";

const GetMerchantSettleVatOut = async (merchantId, merchantSettleId) => {
  try {
    const response = await get(
      `/merchant/${merchantId}/merchantSettle/${merchantSettleId}/vatOut`
    );
    return response;
  } catch (error) {
    console.error("Error GetMerchantSettleVatOut:", error);
    throw error;
  }
};

export default GetMerchantSettleVatOut;
